export default "__VITE_ASSET__vuby1mI9__"